import { simpleValueValidation } from '../core-utils';
import { digger } from '@cbre/digger';
import { defaultTxt } from '../misc/strings.constants';
import { formatDate, MiqMoment } from '../misc/sanitizers';
import { MIQQLParser } from '../miqql-parser';

export const fieldDuplicateChecker = (array, field) => {
  return array.filter(
    (item, index) => simpleValueValidation(item[field]) && array.map(val => val[field]).indexOf(item[field]) === index
  );
};

export const getAndFormatDate = (record, path, defaultText = defaultTxt): any => {
  try {
    const date = digger(record, path);
    return date != null && !!date.trim()
      ? formatDate(MiqMoment.formatFromInputFormat(date, 'YYYY-MM-DD', undefined, true), 'M/d/yyyy', 'en-US')
      : defaultText;
  } catch (e) {
    throw e;
  }
};

export const getFormattedDate = (date): any => {
  return date && formatDate(MiqMoment.formatFromInputFormat(date, 'YYYY-MM-DD'), 'M/d/yyyy', 'en-US');
};

export const getArrayPropAsString = (data, path, separator = ', '): string =>
  (digger(data, path) || []).filter(simpleValueValidation).join(separator);

export const getThisOrThat = (record, defaultText = defaultTxt, ...paths: string[]) => {
  let result = null;
  let i = 0;
  while (!simpleValueValidation(result) && i < paths.length) {
    result = digger(record, paths[i]);
    i++;
  }
  return simpleValueValidation(result) ? { result, index: i - 1 } : { result: defaultText, index: -1 };
};

export const concatValuesBy = (separator = ' | ', ...values: any[]): string =>
  values.filter(simpleValueValidation).join(separator) || defaultTxt;

/**
 * @deprecated not used anymore due to jsonata
 */
export function retrieveDataWithCondition(record: { [attr: string]: any }, path: string, condition: string) {
  let extractedData;
  let parsedCondition;
  try {
    parsedCondition = MIQQLParser.parse(condition);
    extractedData = digger(record, path, parsedCondition);
  } catch {
    extractedData = digger(record, path);
  }
  return extractedData;
}

/**
 * Retrieve value or values, filtering out any null
 */
export function simpleField(record, path: string, defaultText, condition?: string) {
  let val;
  if (simpleValueValidation(condition)) {
    val = retrieveDataWithCondition(record, path, condition);
  } else {
    val = digger(record, path);
  }
  if (Array.isArray(val)) {
    return val.map(element => (simpleValueValidation(element) ? element : defaultText));
  }
  return simpleValueValidation(val) ? val : defaultText;
}

export const excludeDuplicateInObject = function excludeDuplicateObject(array: any[], field: string | Function): any[] {
  const keys: any[] = typeof field === 'function' ? array.map(e => field(e)) : array.map(e => e[field]);
  // redundant result const added so it is easy to debug if required
  const result = keys
    .map((value, index, final) => simpleValueValidation(value) && final.indexOf(value) === index && index)
    .filter(e => array[e])
    .map(e => array[e]);
  return result;
};

export const excludeDuplicateStrings = array => {
  return array.filter((item, index) => simpleValueValidation(item) && array.indexOf(item) === index);
};

export const getFamiliarName = (data: { [key: string]: any }, defaultText = defaultTxt): string =>
  data?.familiar_name?.trim() || defaultText;
